// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar_toolbar__vL1M-","copy":"Toolbar_copy__EnzZC"};